// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"549b25b1426755c4","9777":"d39566facf109320"}[chunkId] + ".js";
};